import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useFormFieldErrorTranslation } from '~/hooks';

interface IntakeChatRequestDescriptionFormProps {
  disabled?: boolean;
  required?: boolean;
  pathPrefix?: string;
}

export const IntakeChatRequestDescriptionForm = ({
  disabled,
  required,
  pathPrefix,
}: IntakeChatRequestDescriptionFormProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeChatRequestDescriptionStep' });

  const { errorToHelperText } = useFormFieldErrorTranslation();
  const fieldName = 'text';
  const path = pathPrefix ? [pathPrefix, fieldName].join('.') : fieldName;

  return (
    <Controller
      name={path}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            fullWidth
            variant="standard"
            size="medium"
            value={field.value || ''}
            helperText={errorToHelperText(error)}
            disabled={disabled || field.disabled}
            required={required}
            label={t('text.label')}
            error={!!error}
            multiline={true}
          />
        );
      }}
    />
  );
};
